import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'

const EducationSkills = () => {
  return (
    <>
      <div className='main-bg-color '>
        <div className="m-t-80 p-80-0">
          <h2 className="text-center title font-cormorant main-light-text-color ">
            Education & Skills
          </h2>
          <div>
            <Container>
              <Row className="education-box-main">
                <Col lg={6} md={6} sm={6}>
                  <div className="skill-bar main-light-text-color main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>90%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>HTML</span>
                          </div>
                          <div className="progress-line html">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>75%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>React js</span>
                          </div>
                          <div className="progress-line reactjs">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>85%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>Wordpress</span>
                          </div>
                          <div className="progress-line Wordpress">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>88%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>UI/UX</span>
                          </div>

                          <div className="progress-line ui-ux">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>70%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>Css3</span>
                          </div>
                          <div className="progress-line css3">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={6} md={6} sm={6}>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>29%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>jQuary</span>
                          </div>
                          <div className="progress-line jquary">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>42%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>Photoshop</span>
                          </div>
                          <div className="progress-line photoshop">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>86%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>Figma</span>
                          </div>
                          <div className="progress-line figma">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>54%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>MongoDB</span>
                          </div>

                          <div className="progress-line mongodb">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="skill-bar main-light-text-color">
                    <Row className="skill-box">
                      <Col xs={2} className="text-align-center">
                        <span>37%</span>
                      </Col>
                      <Col xs={10}>
                        <div className="bar">
                          <div className="info">
                            <span>TypeScript</span>
                          </div>
                          <div className="progress-line typescript">
                            <span></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  )
}

export default EducationSkills